import styled from '@emotion/styled';
import { useDisplayrDashboard } from '@trinity/chat-components/hooks/useDashboard';

const DISPLAYR_DASHBOARD_URL = 'https://app.displayr.com/Dashboard';

/** The URL a Displayr dashboard is embedded from (and opened at). The id is percent-encoded as a query value. */
export const buildDisplayrDashboardUrl = (dashboardId: string): string => {
  const url = new URL(DISPLAYR_DASHBOARD_URL);
  url.searchParams.append('id', dashboardId);
  return url.href;
};

type DisplayrEmbedProps = {
  dashboardId: string;
  /** Accessible name for the frame. */
  title?: string;
  /** CSS height of the frame. Fills its container by default. */
  height?: string;
};

/** A Displayr dashboard, from an id alone. No provider or context needed, so pages and apps can both use it. */
export const DisplayrEmbed = ({ dashboardId, title = 'Displayr Dashboard', height = '100%' }: DisplayrEmbedProps) => {
  if (!dashboardId) return null;

  return <StyledIframe src={buildDisplayrDashboardUrl(dashboardId)} title={title} style={{ height }} />;
};

/** The Displayr dashboard of the surrounding project or brand, sized for the legacy app's tab layout. */
export const DisplayrDashboard = () => {
  const { dashboardId } = useDisplayrDashboard();

  return <DisplayrEmbed dashboardId={dashboardId} height="calc(100vh - var(--navbar-height) - 70px - 40px)" />;
};

const StyledIframe = styled.iframe`
  width: 100%;
  border: none;
  box-shadow: none;
`;
